import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useRetailerStore = create(
  persist(
    (set) => ({
      retailerInfo: null,
      visualizerToken: "",
      visualizerLink: "",

      setRetailerData: (data) => {
        if (!data) return;
        set({
          visualizerToken: data.visualizer_token || data.retailer?.visualizer_token || "",
          visualizerLink: data.visualizer_link || data.retailer?.visualizer_link || "",
          retailerInfo: data.retailer || null,
        });
      },

      clearRetailerData: () =>
        set({
          retailerInfo: null,
          visualizerToken: "",
          visualizerLink: "",
        }),
    }),
    {
      name: "retailer-storage", // Key name in localStorage
    }
  )
);